export default class PromotionsHelperSpreadsheet {
  constructor(parent) {
    this.parent = parent;
  }

  getMTOPromotions() {
    return {};
  }

  getMTOPromotionTooltips() {
    return {};
  }

  getColourTrimPromotionsMTO() {
    return {};
  }

  getColourTrimPromotions() {
      return {};
  }

  getColourTrimPromotions() {
      return {};
  }

  getColourTrimPromotionTooltips() {    
      return {};
  }

  getAccessoryPromotionsMTO() {
      return {};
  }

  getAccessoryPromotions() {
      return {};
  }

  getAccessoryPromotionTooltips() {
    return {};
  }

  getAdditionalProductPromotions() {
    return {};
  }

  getAdditionalProductPromotionTooltips() {
    return {};
  }

  getAdditionalProductPromotionTooltips() {    
    return {};
  }

  getCarColourTrimPromitions() {
    return {};
  }
  
  getCarColourTrimTooltip() {
    return {};
  }

  getCarMTOCEPromotions() {
    return [];
  }

  getCarAdditionalProductPromotions() {    
    return [];
  }

  getCarPromotions() {
    return [];
  }

  getCarPromotionsDiscountTotal() {
    return null;
  }

  addTooltip(promotion) {
    return {};
  }

  tooltipOnCreate(instance) { }
}